(function () {
  function initBrandAnimations() {
    if (!document.body.classList.contains('is-brand-page')) return;
    if (!window.gsap) return;

    if (window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', function () {
      gsap.from('[data-brand-reveal]', {
        y: 80,
        opacity: 0,
        duration: 1,
        ease: 'power3.out',
        stagger: 0.12,
        scrollTrigger: {
          trigger: '[data-brand-reveal]',
          start: 'top 82%',
        },
      });
    });

    mm.add('(max-width: 900px)', function () {
      gsap.from('[data-brand-reveal]', {
        y: 36,
        opacity: 0,
        duration: 0.7,
        ease: 'power2.out',
        stagger: 0.08,
        scrollTrigger: {
          trigger: '[data-brand-reveal]',
          start: 'top 88%',
        },
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initBrandAnimations);
})();
